import React, { useEffect, useState } from 'react';
import { collectRoles, hasRole } from '../utils/roles';
import { apiUrl } from '../config/api';

export default function UsersAdminPage(){
  const token = (typeof window!=='undefined') ? (localStorage.getItem('authToken')||'') : '';
  let user = null; let isSuper = false; let isAdmin = false;
  try {
    user = JSON.parse(localStorage.getItem('authUser')||'null');
    isSuper = ['1001','1002'].includes(String(user?.id));
    const roles = collectRoles(user);
    isAdmin = hasRole(roles, 'admin');
  } catch {}
  const canManage = isSuper || isAdmin;

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ id:'', name:'', roles:['manager'], password:'', mustChangePassword:true });
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({ name:'', roles:[], password:'', mustChangePassword:false });
  const [error, setError] = useState('');
  const [mustChangeBusy, setMustChangeBusy] = useState(null);
  const [blockBusy, setBlockBusy] = useState(null);
  const [autoOverrideBusy, setAutoOverrideBusy] = useState(null);
  const [filters, setFilters] = useState({ employeeCode: '', fio: '' });

  const filteredList = list.filter((u) => {
    const codeNeedle = String(filters.employeeCode || '').trim().toLowerCase();
    const fioNeedle = String(filters.fio || '').trim().toLowerCase();
    const codeValue = String(u?.id || '').toLowerCase();
    const fioValue = String(u?.name || '').toLowerCase();
    const codeMatch = !codeNeedle || codeValue.includes(codeNeedle);
    const fioMatch = !fioNeedle || fioValue.includes(fioNeedle);
    return codeMatch && fioMatch;
  });

  function roleName(r){
    switch(r){
      case 'manager': return 'Менеджер объекта';
      case 'assistant': return 'Ассистент';
      case 'gd': return 'ГД';
      case 'admin': return 'Админ';
      case 'hr': return 'Кадры';
      case 'tech': return 'Тех.персонал';
      default: return r;
    }
  }

  function load(){
    if (!canManage) return;
    setLoading(true); setError('');
    fetch(apiUrl('/api/users'), { headers: token? { Authorization: `Bearer ${token}` } : {} })
      .then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=>{
        if (!ok){ setError(data?.error||'Ошибка загрузки'); setList([]); return; }
        const normalized = Array.isArray(data)
          ? data.map(u => ({
              ...u,
              mustChangePassword: Number(u?.mustChangePassword) ? 1 : 0,
              isBlockedManual: Number(u?.isBlockedManual) ? 1 : 0,
              isBlockedAuto: Number(u?.isBlockedAuto) ? 1 : 0,
              autoBlockOverride: Number(u?.autoBlockOverride) || 0
            }))
          : [];
        setList(normalized);
      })
      .catch(()=> setError('Сбой сети'))
      .finally(()=> setLoading(false));
  }

  useEffect(()=>{ load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onCreate(e){
    e.preventDefault(); if (!canManage) return;
    if (!form.id || !form.name || !form.password){ alert('ID, имя и пароль обязательны'); return; }
    if (!form.roles.length){ alert('Выберите хотя бы одну роль'); return; }
    setSaving(true);
    fetch(apiUrl('/api/users'), {
      method:'POST', headers:{ 'Content-Type':'application/json', ...(token? { Authorization: `Bearer ${token}` }: {}) },
      body: JSON.stringify({ id: form.id, name: form.name, password: form.password, roles: form.roles, mustChangePassword: form.mustChangePassword })
    }).then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=>{
        if (!ok){ alert('Ошибка: '+(data?.error||'unknown')); }
  setForm({ id:'', name:'', roles:['manager'], password:'', mustChangePassword:true });
        load();
      })
      .catch(()=> alert('Сбой сети'))
      .finally(()=> setSaving(false));
  }

  function startEdit(u){ setEditingId(u.id); setEditForm({ name:u.name, roles:Array.isArray(u.roles)?u.roles:[u.role], password:'', mustChangePassword: !!u.mustChangePassword }); }
  function cancelEdit(){ setEditingId(null); setEditForm({ name:'', roles:[], password:'', mustChangePassword:false }); }

  function saveEdit(id){
    if (!canManage) return; if (!id) return;
    const payload = {}; if (editForm.name && editForm.name!==list.find(x=>x.id===id)?.name) payload.name = editForm.name;
    const orig = list.find(x=>x.id===id);
    const origRoles = Array.isArray(orig?.roles)? orig.roles : [orig?.role].filter(Boolean);
    if (Array.isArray(editForm.roles)){
      const changed = editForm.roles.length !== origRoles.length || editForm.roles.some(r=> !origRoles.includes(r));
      if (changed) payload.roles = editForm.roles;
    }
    if (editForm.password) payload.password = editForm.password;
    if (typeof editForm.mustChangePassword === 'boolean' && editForm.mustChangePassword !== Boolean(orig?.mustChangePassword)) {
      payload.mustChangePassword = editForm.mustChangePassword;
    }
    if (!Object.keys(payload).length){ cancelEdit(); return; }
    fetch(apiUrl(`/api/users/${encodeURIComponent(id)}`), {
      method:'PATCH', headers:{ 'Content-Type':'application/json', ...(token? { Authorization: `Bearer ${token}` }: {}) },
      body: JSON.stringify(payload)
    }).then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
    .then(({ok,data})=>{ if (!ok){ alert('Ошибка: '+(data?.error||'unknown')); } load(); cancelEdit(); })
      .catch(()=> alert('Сбой сети'));
  }

  function quickToggleMustChange(id, value){
    if (!canManage) return;
    setMustChangeBusy(id);
    const prevValue = Number(list.find(u => u.id === id)?.mustChangePassword) ? 1 : 0;
    setList(prev => prev.map(u => u.id === id ? { ...u, mustChangePassword: value ? 1 : 0 } : u));
    fetch(apiUrl(`/api/users/${encodeURIComponent(id)}`), {
      method:'PATCH', headers:{ 'Content-Type':'application/json', ...(token? { Authorization: `Bearer ${token}` }: {}) },
      body: JSON.stringify({ mustChangePassword: value })
    }).then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=>{ if (!ok){ alert('Ошибка: '+(data?.error||'unknown')); setList(prev => prev.map(u => u.id === id ? { ...u, mustChangePassword: prevValue } : u)); } })
      .catch(()=> { alert('Сбой сети'); setList(prev => prev.map(u => u.id === id ? { ...u, mustChangePassword: prevValue } : u)); })
      .finally(()=> { setMustChangeBusy(null); load(); });
  }

  function toggleManualBlock(id, value){
    if (!canManage || !id) return;
    if (blockBusy) return;
    const prevValue = Number(list.find(u => u.id === id)?.isBlockedManual) ? 1 : 0;
    setBlockBusy(id);
    setList(prev => prev.map(u => u.id === id ? { ...u, isBlockedManual: value ? 1 : 0 } : u));
    fetch(apiUrl(`/api/users/${encodeURIComponent(id)}`), {
      method:'PATCH', headers:{ 'Content-Type':'application/json', ...(token? { Authorization: `Bearer ${token}` }: {}) },
      body: JSON.stringify({ isBlockedManual: !!value })
    }).then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=>{
        if (!ok){
          alert('Ошибка: '+(data?.error||'unknown'));
          setList(prev => prev.map(u => u.id === id ? { ...u, isBlockedManual: prevValue } : u));
        }
      })
      .catch(()=> {
        alert('Сбой сети');
        setList(prev => prev.map(u => u.id === id ? { ...u, isBlockedManual: prevValue } : u));
      })
      .finally(()=> { setBlockBusy(null); load(); });
  }

  function toggleAutoBlockOverride(id, overrideValue){
    if (!isSuper) return;
    if (!id) return;
    setAutoOverrideBusy(id);
    fetch(apiUrl(`/api/users/${encodeURIComponent(id)}`), {
      method:'PATCH', headers:{ 'Content-Type':'application/json', ...(token? { Authorization: `Bearer ${token}` }: {}) },
      body: JSON.stringify({ autoBlockOverride: overrideValue })
    }).then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=>{
        if (!ok){ alert('Ошибка: '+(data?.error||'unknown')); }
      })
      .catch(()=> alert('Сбой сети'))
      .finally(()=> { setAutoOverrideBusy(null); load(); });
  }

  function del(id){
    if (!canManage) return;
    if (!window.confirm('Удалить пользователя '+id+'?')) return;
    fetch(apiUrl(`/api/users/${encodeURIComponent(id)}`), {
      method:'DELETE', headers:{ ...(token? { Authorization: `Bearer ${token}` }: {}) }
    }).then(r=> r.json().then(d=>({ ok:r.ok, data:d })))
      .then(({ok,data})=>{ if (!ok){ alert('Ошибка: '+(data?.error||'unknown')); } load(); })
      .catch(()=> alert('Сбой сети'));
  }

  if (!canManage){
    return <div style={{ padding:'32px 20px', maxWidth:800, margin:'0 auto' }}><h2>Управление пользователями</h2><div>Недостаточно прав (нужно Admin или Super)</div></div>;
  }

  return (
    <div style={{ padding:'32px 20px', maxWidth:1100, margin:'0 auto' }}>
      <h2 style={{ marginTop:0 }}>Управление пользователями</h2>
      {error && <div style={{ color:'#c00', marginBottom:12 }}>{error}</div>}

  <form onSubmit={onCreate} style={{ display:'flex', flexWrap:'wrap', gap:12, background:'#fafafa', padding:'12px 14px', borderRadius:8, border:'1px solid #e1e4eb' }}>
        <div style={{ display:'flex', flexDirection:'column' }}>
          <label>ID *</label>
          <input value={form.id} onChange={e=> setForm(s=>({ ...s, id:e.target.value }))} style={{ padding:'6px 8px' }} />
        </div>
        <div style={{ display:'flex', flexDirection:'column', minWidth:200 }}>
          <label>Имя *</label>
          <input value={form.name} onChange={e=> setForm(s=>({ ...s, name:e.target.value }))} style={{ padding:'6px 8px' }} />
        </div>
        <fieldset style={{ border:'1px solid #ddd', padding:'6px 10px', borderRadius:6, display:'flex', flexDirection:'column', gap:4 }}>
          <legend style={{ fontSize:12 }}>Роли *</legend>
          {['manager','assistant','gd','admin','hr','tech'].map(r=> (
            <label key={r} style={{ fontSize:13 }}>
              <input type='checkbox' checked={form.roles.includes(r)} onChange={e=> {
                setForm(s=> ({ ...s, roles: e.target.checked ? [...s.roles, r] : s.roles.filter(x=> x!==r) }));
              }} /> {roleName(r)}
            </label>
          ))}
        </fieldset>
        <div style={{ display:'flex', flexDirection:'column' }}>
          <label>Пароль *</label>
          <input value={form.password} onChange={e=> setForm(s=>({ ...s, password:e.target.value }))} style={{ padding:'6px 8px' }} type='password' />
        </div>
        <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:13 }}>
          <input type='checkbox' checked={!!form.mustChangePassword} onChange={e=> setForm(s=>({ ...s, mustChangePassword: e.target.checked }))} />
          Требовать смену при первом входе
        </label>
        <div style={{ display:'flex', flexDirection:'column', justifyContent:'flex-end' }}>
          <button disabled={saving} style={{ padding:'8px 14px', background:'#e0f7e9', border:'1px solid #4caf50', cursor:'pointer' }}>Создать</button>
        </div>
      </form>

      <div style={{ marginTop:24 }}>
        <h3 style={{ margin:'0 0 12px' }}>Список пользователей</h3>
        {loading && <div>Загрузка…</div>}
        {!loading && (
          <div style={{ overflowX:'auto' }}>
            <table style={{ borderCollapse:'collapse', width:'100%' }}>
              <thead>
                <tr style={{ background:'#f5f7fa' }}>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>ID</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Имя</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Роль</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Смена пароля</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Доступ</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Создан</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Обновлён</th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>Действия</th>
                </tr>
                <tr style={{ background:'#fbfcfe' }}>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>
                    <input
                      value={filters.employeeCode}
                      onChange={e=> setFilters(s=>({ ...s, employeeCode: e.target.value }))}
                      placeholder="Поиск кода"
                      style={{ width:'100%', padding:'6px 8px', boxSizing:'border-box', border:'1px solid #cfd6e3', borderRadius:6, fontSize:12 }}
                    />
                  </th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}>
                    <input
                      value={filters.fio}
                      onChange={e=> setFilters(s=>({ ...s, fio: e.target.value }))}
                      placeholder="Поиск ФИО"
                      style={{ width:'100%', padding:'6px 8px', boxSizing:'border-box', border:'1px solid #cfd6e3', borderRadius:6, fontSize:12 }}
                    />
                  </th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}></th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}></th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}></th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}></th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}></th>
                  <th style={{ border:'1px solid #dfe3e9', padding:'6px 8px' }}></th>
                </tr>
              </thead>
              <tbody>
                {filteredList.map(u => {
                  const editing = editingId === u.id;
                  const manualBlocked = Number(u.isBlockedManual) ? 1 : 0;
                  const autoBlocked = Number(u.isBlockedAuto) ? 1 : 0;
                  const autoOverride = Number(u.autoBlockOverride) || 0;
                  const blocked = !!(manualBlocked || autoBlocked);
                  return (
                    <tr key={u.id} style={{ background: editing? '#fffbe6':'#fff' }}>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px' }}>{u.id}</td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px' }}>
                        {editing ? <input value={editForm.name} onChange={e=> setEditForm(s=>({ ...s, name:e.target.value }))} style={{ padding:'4px 6px' }} /> : u.name}
                      </td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px' }}>
                        {editing ? (
                          <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
                            {['manager','assistant','gd','admin','hr','tech'].map(r=> (
                              <label key={r} style={{ fontSize:12 }}>
                                <input type='checkbox' checked={editForm.roles.includes(r)} onChange={e=> {
                                  setEditForm(s=> ({ ...s, roles: e.target.checked ? [...s.roles, r] : s.roles.filter(x=> x!==r) }));
                                }} /> {roleName(r)}
                              </label>
                            ))}
                          </div>
                        ) : (
                          <span>{(Array.isArray(u.roles)?u.roles:[u.role]).map(r=> roleName(r)).join(', ')}</span>
                        )}
                      </td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px', fontSize:12 }}>
                        {editing ? (
                          <label style={{ display:'inline-flex', alignItems:'center', gap:6 }}>
                            <input type='checkbox' checked={!!editForm.mustChangePassword} onChange={e=> setEditForm(s=> ({ ...s, mustChangePassword: e.target.checked }))} />
                            Требовать смену
                          </label>
                        ) : (
                          <label style={{ display:'inline-flex', alignItems:'center', gap:6 }}>
                            <input
                              type='checkbox'
                              checked={!!u.mustChangePassword}
                              disabled={!!mustChangeBusy}
                              onChange={e=> quickToggleMustChange(u.id, e.target.checked)}
                            />
                            Требовать смену
                          </label>
                        )}
                      </td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px', fontSize:12 }}>
                        <div style={{ display:'flex', flexDirection:'column', gap:2 }}>
                          <span style={{ fontWeight:600, color: blocked ? '#b91c1c' : '#15803d' }}>
                            {blocked ? 'Заблокирован' : 'Активен'}
                          </span>
                          {autoBlocked ? (
                            <span style={{ fontSize:11, color:'#9f1239' }}>
                              Авто: {autoOverride === -1 ? 'отключено суперюзером' : 'сотрудник уволен'}
                            </span>
                          ) : manualBlocked ? (
                            <span style={{ fontSize:11, color:'#92400e' }}>Выключен вручную</span>
                          ) : null}
                          {autoOverride === 1 && (
                            <span style={{ fontSize:11, color:'#b45309' }}>Принудительный автоблок</span>
                          )}
                        </div>
                      </td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px', fontSize:12 }}>{new Date(u.createdAt).toLocaleString('ru-RU')}</td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px', fontSize:12 }}>{new Date(u.updatedAt).toLocaleString('ru-RU')}</td>
                      <td style={{ border:'1px solid #ebeef2', padding:'6px 8px' }}>
                        {editing ? (
                          <div style={{ display:'flex', gap:6 }}>
                            <input placeholder='Новый пароль (опц.)' type='password' value={editForm.password} onChange={e=> setEditForm(s=>({ ...s, password:e.target.value }))} style={{ padding:'4px 6px' }} />
                            <button onClick={()=> saveEdit(u.id)} style={{ background:'#e0f2ff', border:'1px solid #2196f3', padding:'4px 8px' }}>Сохранить</button>
                            <button onClick={cancelEdit} style={{ background:'#f0f0f0', border:'1px solid #bbb', padding:'4px 8px' }}>Отмена</button>
                          </div>
                        ) : (
                          <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                            <button
                              onClick={()=> toggleManualBlock(u.id, !manualBlocked)}
                              disabled={blockBusy===u.id || (autoBlocked && !isSuper)}
                              title={autoBlocked && !isSuper ? 'Автоблок включен HR' : ''}
                              style={{ background: manualBlocked ? '#fee2e2' : '#f1f5f9', border:'1px solid #94a3b8', padding:'4px 8px', cursor: (autoBlocked && !isSuper) ? 'not-allowed' : 'pointer' }}
                            >
                              {manualBlocked ? 'Снять блок' : 'Заблок.'}
                            </button>
                            {isSuper && (autoBlocked || autoOverride === -1) && (
                              <button
                                onClick={()=> toggleAutoBlockOverride(u.id, autoOverride === -1 ? 0 : -1)}
                                disabled={autoOverrideBusy===u.id}
                                style={{ background:'#dbeafe', border:'1px solid #2563eb', padding:'4px 8px' }}
                              >
                                {autoOverride === -1 ? 'Вернуть автоблок' : 'Снять автоблок'}
                              </button>
                            )}
                            {isSuper && autoOverride !== 1 && !autoBlocked && (
                              <button
                                onClick={()=> toggleAutoBlockOverride(u.id, 1)}
                                disabled={autoOverrideBusy===u.id}
                                style={{ background:'#fee2e2', border:'1px solid #b91c1c', padding:'4px 8px' }}
                              >
                                Принуд. автоблок
                              </button>
                            )}
                            {isSuper && autoOverride === 1 && (
                              <button
                                onClick={()=> toggleAutoBlockOverride(u.id, 0)}
                                disabled={autoOverrideBusy===u.id}
                                style={{ background:'#fef3c7', border:'1px solid #d97706', padding:'4px 8px' }}
                              >
                                Снять принуд.
                              </button>
                            )}
                            <button onClick={()=> startEdit(u)} style={{ background:'#fff3e0', border:'1px solid #fb8c00', padding:'4px 8px' }}>Изм.</button>
                            {String(user?.id)!==String(u.id) && <button onClick={()=> del(u.id)} style={{ background:'#ffe6e6', border:'1px solid #f44336', padding:'4px 8px' }}>Удалить</button>}
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
